import React, { useEffect, useState } from "react";

import moment from "moment";
import { MDBTableHead, MDBTable, MDBTableBody } from "mdbreact";
import { Loader } from "../../../../../../../../UI/Loaders/Loaders";
import { appInsights } from "../../../../../../../../config/appInsights";
import { useCustomerTransactions } from "../../../../../../../../custom-hooks/useCustomerTransactions";
import { useLocation, useRouteMatch } from "react-router-dom";
import { formatMoney } from "../../../../../../../../helpers/formatter";
import Paginator from "../../../../../../../Pagination/Pagination.component";
import styles from "../../../../../../IndividualCustomers/Components/Transactions/transaction.module.scss";
import { message } from "antd";

const Transactions = () => {
  const [query, setQuery] = useState({
    page: 1,
    pageSize: 10,
  });

  const [searchQuery, setSearchQuery] = useState({
    startDate: "",
    endDate: "",
    paymentReference: "",
  });
  const [filterValue, setFilterValue] = useState({
    startDate: "",
    endDate: "",
    paymentReference: "",
  });

  const location = useLocation();

  const state = location.state as {
    customerId: number;
    accountNumber: string;
    accountName: string;
    walletProvider: string;
  };

  useEffect(() => {
    appInsights.trackPageView({
      name: "Transactions.tsx",
      isLoggedIn: true,
    });
  }, []);

  const queryParams = {
    accountNumber: state?.accountNumber,
    customerId: state?.customerId,
    page: query.page,
    pageSize: query.pageSize,
    ...searchQuery,
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFilterValue((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const onSearch = () => {
    if (!filterValue.startDate && !filterValue.endDate) {
      message.error("Please select a date range");
      return;
    }
    setSearchQuery(filterValue);
  };

  const onClear = () => {
    setSearchQuery({
      startDate: "",
      endDate: "",
      paymentReference: "",
    });

    setFilterValue({
      startDate: "",
      endDate: "",
      paymentReference: "",
    });
  };

  const {
    data: customerTransactions,
    status,
    error,
  } = useCustomerTransactions(queryParams);

  let RenderedComponent = null;
  if (!customerTransactions && status !== "loading") {
    RenderedComponent = (
      <div>
        <div className="grid__padding animated fadeInRight">
          <h4 className="center-txt">
            <i className="fas fa-bell" /> Unable to Fetch Transactions
          </h4>
        </div>
      </div>
    );
  } else if (status === "loading") {
    RenderedComponent = (
      <Loader centered={true} text="Loading Transactions..." />
    );
  } else {
    if (error) {
      RenderedComponent = (
        <div>
          <div className="grid__padding animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> There was an issue while fetching
              Transactions Please Reload The Page{" "}
            </h4>
          </div>
        </div>
      );
    } else if (
      (customerTransactions &&
        customerTransactions.data &&
        customerTransactions.data.length === 0) ||
      (customerTransactions && !customerTransactions.data)
    ) {
      RenderedComponent = (
        <div className="centerLoader">
          <div className="grid__padding animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> There are currently no transactions
            </h4>
          </div>
        </div>
      );
    } else {
      RenderedComponent = (
        <>
          <MDBTable
            responsive
            minimal="true"
            striped={false}
            bordered
            hover
            id="table-to-xls"
          >
            <MDBTableHead>
              <tr>
                <th>Session ID</th>
                <th>Transaction Type</th>
                <th>Amount</th>
                <th>Transaction Date</th>
                <th>Account No</th>
                <th>Balance</th>
                <th>Narration</th>
              </tr>
            </MDBTableHead>
            <MDBTableBody>
              {customerTransactions &&
                customerTransactions.data.map((data, _id: number) => {
                  const {
                    balance,
                    clientId,
                    currencyCode,
                    narration,
                    transactionAmount,
                    transactionDate,
                    transactionType,
                    accountNumber,
                    sessionId,
                  } = data;
                  return (
                    <tr key={Math.random() * clientId}>
                      <td>{sessionId ? sessionId : "N/A"}</td>
                      <td>{transactionType}</td>
                      <td>{formatMoney(transactionAmount, currencyCode)}</td>
                      <td>
                        {transactionDate
                          ? moment(transactionDate).format("DD-MM-YYYY")
                          : ""}
                      </td>
                      <td>{accountNumber}</td>
                      <td>{formatMoney(balance, currencyCode)}</td>
                      <td>{narration}</td>
                    </tr>
                  );
                })}
            </MDBTableBody>
          </MDBTable>
        </>
      );
    }
  }

  return (
    <div className="table-view speed-1x animated fadeInRight">
      <div className={styles.searchContainer}>
        <input
          type="text"
          className={styles.searchStringInputField}
          onChange={(e) => handleChange(e)}
          value={filterValue.paymentReference}
          name="paymentReference"
          placeholder="Search by Session ID, Ref No, Account No"
        />

        <div className={styles.dateContainer}>
          <div className={styles.startDate}>
            <label>From</label>
            <input
              type="date"
              className={styles.dateStringInputField}
              name="startDate"
              value={filterValue.startDate}
              onChange={(e) => handleChange(e)}
            />
          </div>
          <div className={styles.endDate}>
            <label>To</label>
            <input
              type="date"
              className={styles.dateStringInputField}
              name="endDate"
              value={filterValue.endDate}
              onChange={(e) => handleChange(e)}
            />
          </div>
        </div>

        <div className={styles.btnContainer}>
          <button type="button" className={styles.clearBtn} onClick={onClear}>
            clear
          </button>
          <button
            type="button"
            className={styles.searchBtn}
            onClick={onSearch}
            disabled={!filterValue.startDate || !filterValue.endDate}
          >
            Search
          </button>
        </div>
      </div>
      <div>{RenderedComponent}</div>

      <Paginator
        size={query.pageSize}
        page={query.page}
        count={customerTransactions?.totalCount}
        changeCurrentPage={(pageNumber: number) =>
          setQuery((prev) => {
            return {
              ...prev,
              page: pageNumber,
            };
          })
        }
      />
    </div>
  );
};

export default Transactions;
